export const LOGO_STATIC_URI = require('../../assets/images/vLogo.png');
export const BACKGROUND_IMAGE = require('../../assets/images/wedoverify-gif.gif');
export const PROV_CARD_BG_WALLPAPER = require('../../assets/images/cert.png');
export const MOBILE_BACKGROUND_IMAGE = require('../../assets/images/mobile-bg.png');